// Stable per-browser id so each till can tell its own chat messages from the other store's,
// even though every till signs in with the same account.
export const getTillId = () => {
  let id = localStorage.getItem('till_id');
  if (!id) {
    id = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem('till_id', id);
  }
  return id;
};
